import React, { useEffect, useState } from "react";
import {
  AttachmentField,
  Button,
  Divider,
  FormFieldSet,
  PageHeader,
  PageTitle,
  useFormHandler,
  Modal,
  showToast,
  Chip,
  DocumentsList,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { useAttachmentHandlers } from "../../../../../../hooks/useAttachmentHandlers";
import ResetModal from "./LcaTabModals/ResetModal";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { addNewImmigrationsStart } from "../../../../../../redux/slices/immigration/immigrationSlice";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { getEmployeeByUiidStart } from "../../../../../../redux/slices/employee/employeeSlice";
import {
  LcaAdsPostAt,
  LcaStatus,
  visaClassificationOptions,
} from "../../../../../../assets/data/enumData";
import {
  cityStateListOptions,
  countryListOptions,
} from "../../../../../../assets/data/projectData";
import { label } from "framer-motion/client";
import { transformFiles } from "../../../../../../utils/transformFiles";
const LCAInformation = ({ setActiveTab, editData = null }) => {
  const isEditable = !!editData;
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
  const { immigrations: immigrationTableData, currentImmgration } = useSelector(
    (state) => state.immigration,
  );
  const { userData: loginUserData } = useLoginUser();
  const dispatch = useDispatch();
  const [activeTabInner, setActiveTabInner] = useState(1);
  const [showResetModal, setShowResetModal] = useState(false);
  const [tabToReset, setTabToReset] = useState(null);
  const [activeAdTab, setActiveAdTab] = useState(1);
  const [validationRules, setValidationRules] = useState({});
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [attchmentModalName, setAttachmentModalName] = useState("");
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const immigrationUiid =
    employeeDetails?.immigrations?.length > 0
      ? employeeDetails.immigrations[0]
      : "";
  const initialFormData = {
    lcaNumber: "",
    lcaStatus: "",
    jobTitle: "",
    employmentStartDate: "",
    employmentEndDate: "",
    certificationDate: "",
    positionsRequested: "",
    socCode: "",
    socOccupationTitle: "",
    includePoNumber: "exempt",
    visaClassification: [{ id: uuidv4(), visaClasificationSelect: [] }],
    certifiedLCA: [],
    paperLCA: [],
    wageRateUSD: "",
    wageRateFromUSD: "",
    wageRateToUSD: "",
    wageRatePer: "",
    wageLevel: "",
    sourceYear: "",
    sourceFrom: "",
    sourceTo: "",
    documentType: "",
    employmentPlace: {
      place1: {
        id: uuidv4(),
        endClient: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place2: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place3: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
      place4: {
        id: uuidv4(),
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        county: "",
        zipCode: "",
        prevailingWageUSD: "",
      },
    },
    // advertisements: {
    //   ad1: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad2: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad3: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    //   ad4: {
    //     id: uuidv4(),
    //     advertisementType: "",
    //     postedAt: "",
    //     displayedFrom: "",
    //     displayedUntil: "",
    //     attachment: [],
    //     displayOnDashboard: "",
    //   },
    // },
    attachments: [
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  console.log({ formData });
  useEffect(() => {
    let baseRules = {};
    if (!editData?.uiid) {
      baseRules = {
        paperLCA: {
          type: "file",
          required: true,
        },
        certifiedLCA: {
          type: "file",
          required: true,
        },
        socCode: {
          type: "text",
          required: true,
        },
        lcaStatus: {
          type: "select",
          required: true,
          number: true,
        },
        jobTitle: {
          type: "select",
          required: true,
        },
        employmentStartDate: {
          type: "date",
          required: true,
        },
        employmentEndDate: {
          type: "date",
          required: true,
        },
        certificationDate: {
          type: "date",
          required: true,
        },
        positionsRequested: {
          type: "text",
          required: true,
        },
        socOccupationTitle: {
          type: "text",
          required: true,
        },
        // includePoNumber: {
        //   type: "radio",
        //   required: true,
        // },
        wageRateUSD: {
          type: "text",
          required: true,
          number: true,
        },
        wageRateFromUSD: {
          type: "text",
          required: true,
          number: true,
        },
        wageRateToUSD: {
          type: "text",
          // required: true,
          number: true,
        },
        wageRatePer: {
          type: "select",
          required: true,
          number: true,
        },
        wageLevel: {
          type: "text",
          // required: true,
        },
        lcaNumber: {
          type: "text",
          required: true,
        },
        // employmentPlace: {
        //   place1: {
        //     prevailingWageUSD: {
        //       type: "text",
        //       required: true,
        //       number: true
        //     },
        //     endClient: {
        //       type: "text",
        //       required: true,
        //       number: true
        //     }
        //   }
        // },
        attachments: [{ chooseFiles: { type: "file" } }],
      };
    } else {
      baseRules = {
        // not run vaidation on edits
        // paperLCA: {
        //   type: "file",
        //   required: true,
        // },
        // certifiedLCA: {
        //   type: "file",
        //   required: true,
        // },
        socCode: {
          type: "text",
          required: true,
        },
        lcaStatus: {
          type: "select",
          required: true,
          number: true,
        },
        jobTitle: {
          type: "select",
          required: true,
        },
        employmentStartDate: {
          type: "date",
          required: true,
        },
        employmentEndDate: {
          type: "date",
          required: true,
        },
        certificationDate: {
          type: "date",
          required: true,
        },
        positionsRequested: {
          type: "text",
          required: true,
        },
        socOccupationTitle: {
          type: "text",
          required: true,
        },
        // includePoNumber: {
        //   type: "radio",
        //   required: true,
        // },
        wageRateUSD: {
          type: "text",
          required: true,
          number: true,
        },
        wageRateFromUSD: {
          type: "text",
          required: true,
          number: true,
        },
        wageRateToUSD: {
          type: "text",
          // required: true,
          number: true,
        },
        wageRatePer: {
          type: "select",
          required: true,
          number: true,
        },
        wageLevel: {
          type: "text",
          // required: true,
        },
        lcaNumber: {
          type: "text",
          required: true,
        },
        // employmentPlace: {
        //   place1: {
        //     prevailingWageUSD: {
        //       type: "text",
        //       required: true,
        //       number: true
        //     },
        //     endClient: {
        //       type: "text",
        //       required: true,
        //       number: true
        //     }
        //   }
        // },
        attachments: [{ chooseFiles: { type: "file" } }],
      };
    }
    setValidationRules(baseRules);
  }, [editData?.uiid]);

  const handleAddVisaRow = () => {
    const newRow = {
      id: uuidv4(),
      visaClasificationSelect: [],
    };

    setFormData((prev) => ({
      ...prev,
      visaClassification: [...prev.visaClassification, newRow],
    }));
  };

  const handleRemoveVisaRow = (id) => {
    const updatedVisa = formData.visaClassification.filter(
      (row) => row.id !== id,
    );
    setFormData({ ...formData, visaClassification: updatedVisa });
  };

  const handleVisaChange = (index, field, value) => {
    const updatedRows = [...formData.visaClassification];
    updatedRows[index][field] = value;
    setFormData({ ...formData, visaClassification: updatedRows });
  };

  const handleEmploymentPlaceChange = (field, value) => {
    const placeKey = `place${activeTabInner}`;
    setFormData({
      ...formData,
      employmentPlace: {
        ...formData.employmentPlace,
        [placeKey]: {
          ...formData.employmentPlace[placeKey],
          [field]: value,
        },
      },
    });
  };

  const handleAdvertisementChange = (field, value) => {
    const adKey = `ad${activeAdTab}`;
    setFormData((prevFormData) => {
      const updatedData = {
        ...prevFormData,
        advertisements: {
          ...prevFormData.advertisements,
          [adKey]: {
            ...prevFormData.advertisements[adKey],
            [field]: value,
          },
        },
      };

      return updatedData;
    });
  };

  const openResetModal = (tabIndex) => {
    setTabToReset(tabIndex);
    setShowResetModal(true);
  };

  const closeResetModal = () => {
    setShowResetModal(false);
    setTabToReset(null);
  };

  const handleResetEmploymentPlace = () => {
    const placeKey = `place${tabToReset}`;
    const resetPlace = {
      id: uuidv4(),
      addressLine1: "",
      addressLine2: "",
      city: "",
      country: "",
      state: "",
      county: "",
      zipCode: "",
      prevailingWageUSD: "",
    };

    // Add endClient only for first tab
    if (tabToReset === 1) {
      resetPlace.endClient = "";
    }

    setFormData({
      ...formData,
      employmentPlace: {
        ...formData.employmentPlace,
        [placeKey]: resetPlace,
      },
    });
    closeResetModal();
  };

  const { renderAttachments } = useAttachmentHandlers(
    formData,
    handleChange,
    errors,
  );
  //mahee
  const handleSave = async () => {
    try {
      const isValid = validateAllFields();
      if (isValid) {
        const lca = {
          number: formData.lcaNumber,
          status: formData.lcaStatus,
          jobTitle: formData.jobTitle?.value ?? formData.jobTitle,
          employeeId: employeeProfileUiid,
          startDate: formData.employmentStartDate,
          endDate: formData.employmentEndDate,
          certifyDate: formData.certificationDate,
          positionReq: formData.positionsRequested,
          soc: {
            code: formData.socCode,
            title: formData.socOccupationTitle,
          },
          includePONum: formData.includePoNumber
            ? formData.includePoNumber === "exempt"
              ? true
              : false
            : "",
          visaClassification: formData?.visaClassification.map(
            (data) => data.visaClasificationSelect,
          ),
          salaryInfo: {
            wageRate: formData.wageRateUSD,
            range: {
              from: formData.wageRateFromUSD,
              to: formData.wageRateToUSD,
            },
            level: formData.wageLevel,
            sourceYear: { from: formData.sourceFrom, to: formData.sourceTo },
            duration: formData.wageRatePer,
          },
          placeOfEmployment: [
            {
              endClient: formData.employmentPlace.place1.endClient,
              address: {
                country:
                  formData.employmentPlace.place1.country?.value ??
                  formData.employmentPlace.place1.country,
                state:
                  formData.employmentPlace.place1.state?.value ??
                  formData.employmentPlace.place1.state,
                city:
                  formData.employmentPlace.place1.city?.value ??
                  formData.employmentPlace.place1.city,
                zipCode: formData.employmentPlace.place1.zipCode,
                addressLine1: formData.employmentPlace.place1.addressLine1,
                addressLine2: formData.employmentPlace.place1.addressLine2,
              },
              prevailWage: formData.employmentPlace.place1.prevailingWageUSD,
            },
            {
              endClient: formData.employmentPlace.place2.endClient,
              address: {
                country:
                  formData.employmentPlace.place2.country?.value ??
                  formData.employmentPlace.place2.country,
                state:
                  formData.employmentPlace.place2.state?.value ??
                  formData.employmentPlace.place2.state,
                city:
                  formData.employmentPlace.place2.city?.value ??
                  formData.employmentPlace.place2.city,
                zipCode: formData.employmentPlace.place2.zipCode,
                addressLine1: formData.employmentPlace.place2.addressLine1,
                addressLine2: formData.employmentPlace.place2.addressLine2,
              },
              prevailWage: formData.employmentPlace.place2.prevailingWageUSD,
            },
            {
              endClient: formData.employmentPlace.place3.endClient,
              address: {
                country:
                  formData.employmentPlace.place3.country?.value ??
                  formData.employmentPlace.place3.country,
                state:
                  formData.employmentPlace.place3.state?.value ??
                  formData.employmentPlace.place3.state,
                city:
                  formData.employmentPlace.place3.city?.value ??
                  formData.employmentPlace.place3.city,
                zipCode: formData.employmentPlace.place3.zipCode,
                addressLine1: formData.employmentPlace.place3.addressLine1,
                addressLine2: formData.employmentPlace.place3.addressLine2,
              },
              prevailWage: formData.employmentPlace.place3.prevailingWageUSD,
            },
            {
              endClient: formData.employmentPlace.place4.endClient,
              address: {
                country:
                  formData.employmentPlace.place4.country?.value ??
                  formData.employmentPlace.place4.country,
                state:
                  formData.employmentPlace.place4.state?.value ??
                  formData.employmentPlace.place4.state,
                city:
                  formData.employmentPlace.place4.city?.value ??
                  formData.employmentPlace.place4.city,
                zipCode: formData.employmentPlace.place4.zipCode,
                addressLine1: formData.employmentPlace.place4.addressLine1,
                addressLine2: formData.employmentPlace.place4.addressLine2,
              },
              prevailWage: formData.employmentPlace.place4.prevailingWageUSD,
            },
          ],
          // present diabled
          // advertisements: [
          //   {
          //     type: formData.advertisements.ad1.advertisementType,
          //     id: formData.advertisements.ad1.id,
          //     postedAt: formData.advertisements.ad1.postedAt,
          //     displayed: {
          //       from: formData.advertisements.ad1.displayedFrom,
          //       till: formData.advertisements.ad1.displayedUntil,
          //     },
          //     displayOnDashboard: formData.advertisements.ad1.displayOnDashboard
          //       ? true
          //       : false,
          //   },
          //   {
          //     type: formData.advertisements.ad2.advertisementType,
          //     id: formData.advertisements.ad2.id,
          //     postedAt: formData.advertisements.ad2.postedAt,
          //     displayed: {
          //       from: formData.advertisements.ad2.displayedFrom,
          //       till: formData.advertisements.ad2.displayedUntil,
          //     },
          //     displayOnDashboard: formData.advertisements.ad2.displayOnDashboard
          //       ? true
          //       : false,
          //   },
          //   {
          //     type: formData.advertisements.ad3.advertisementType,
          //     id: formData.advertisements.ad3.id,
          //     postedAt: formData.advertisements.ad3.postedAt,
          //     displayed: {
          //       from: formData.advertisements.ad3.displayedFrom,
          //       till: formData.advertisements.ad3.displayedUntil,
          //     },
          //     displayOnDashboard: formData.advertisements.ad3.displayOnDashboard
          //       ? true
          //       : false,
          //   },
          //   {
          //     type: formData.advertisements.ad4.advertisementType,
          //     id: formData.advertisements.ad4.id,
          //     postedAt: formData.advertisements.ad4.postedAt,
          //     displayed: {
          //       from: formData.advertisements.ad4.displayedFrom,
          //       till: formData.advertisements.ad4.displayedUntil,
          //     },
          //     displayOnDashboard: formData.advertisements.ad4.displayOnDashboard
          //       ? true
          //       : false,
          //   },
          // ],
        };
        const submissionData = filterEmptyValues(lca);
        const submissionDataFilter = {
          ...submissionData,
          // advertisements: submissionData.advertisements?.filter((ad) => {
          //   const keys = Object.keys(ad);
          //   // Remove if exactly 2 keys and they are 'id' and 'displayOnDashboard' with value false
          //   return !(
          //     keys.length === 2 &&
          //     keys.includes("id") &&
          //     keys.includes("displayOnDashboard") &&
          //     ad.displayOnDashboard === false
          //   );
          // }),
        };
        const cleanAttachmentscertifiedLCA =
          Array.isArray(formData.certifiedLCA) &&
          formData.certifiedLCA.length > 0
            ? formData.certifiedLCA.map((file) => {
                file.id = uuidv4(); // ✅ Add id directly
                return file;
              })
            : [];
        const cleanAttachmentspaperLCA =
          Array.isArray(formData.paperLCA) && formData.paperLCA.length > 0
            ? formData.paperLCA.map((file) => {
                file.id = uuidv4(); // ✅ Add id directly
                return file;
              })
            : [];
        // const cleanAttachments = formData.attachments.filter(
        //   (att) =>
        //     att.attachmentName.trim() !== "" ||
        //     att.attachmentComments.trim() !== "" ||
        //     (att.chooseFiles && att.chooseFiles.length > 0)
        // );
        // const cleanattachmentsId = cleanAttachments.flatMap((doc) =>
        //   doc.chooseFiles.map((file) => {
        //     file.id = doc.id;
        //     return file;
        //   })
        // );
        // const separatedFiles = Object.values(formData.advertisements)
        //   .filter(
        //     (doc) => Array.isArray(doc.attachment) && doc.attachment.length > 0
        //   )
        //   .flatMap(
        //     (doc) =>
        //     (doc.attachment = doc.attachment.map((file) => {
        //       file.id = doc.id;
        //       return file;
        //     }))
        //   );
        const combineAllFiles = [
          ...cleanAttachmentscertifiedLCA,
          ...cleanAttachmentspaperLCA,
          // ...cleanattachmentsId,
          // ...separatedFiles,
        ];
        console.log({ combineAllFiles });
        const hasAnyDocs =
          combineAllFiles?.length > 0 ||
          cleanAttachmentscertifiedLCA.length > 0 ||
          cleanAttachmentspaperLCA.length > 0;

        const handleAddImmigration = async (fileData = []) => {
          const updatedSubmissionData = { ...submissionDataFilter };

          const isEditing = !!(currentImmgration?.uiid || editData?.uiid);
          const uiid = isEditing
            ? currentImmgration?.uiid || editData?.uiid
            : "";

          const finalPayload = isEditing
            ? [
                {
                  type: "SET",
                  value: {
                    ...updatedSubmissionData,
                  },
                },
              ]
            : {
                addedBy: loginUserUiid,
                employeeId: formData.employeeId?.value ?? formData.employeeId,
                ...updatedSubmissionData,
              };

          dispatch(
            addNewImmigrationsStart({
              uiid,
              coll: "LCA",
              rsn: "lcaInfo",
              rsd: submissionDataFilter,
              payload: finalPayload,
              onSuccess: async (payload) => {
                const delay = (ms) => new Promise((res) => setTimeout(res, ms));
                const parentId =
                  payload.data.data.lcaId || payload.data.data.doc.uiid;

                // --- certified LCA upload ---
                if (cleanAttachmentscertifiedLCA.length > 0) {
                  dispatch(
                    addDocumentStart({
                      coll: "Document",
                      refColl: "LCA",
                      refId: parentId,
                      refField: "attachments.certified",
                      payload: {
                        addedBy: loginUserUiid,
                        attachments: [
                          {
                            parent: { employee: employeeProfileUiid },
                            addedBy: loginUserUiid,
                            docType: "certified LCA",
                            ref: {
                              id: parentId,
                              entity: "LCA",
                              path: `attachments.certified`,
                            },
                            file: cleanAttachmentscertifiedLCA.map((obj) => ({
                              name: "certified LCA",
                              comments: "certified LCA",
                              keys: fileData
                                .filter(
                                  (file) =>
                                    file?.fileRefId === obj.id && file.key,
                                )
                                .map((file) => file.key),
                            })),
                          },
                        ],
                      },
                    }),
                  );
                  await delay(300);
                }

                // --- paper LCA upload ---
                if (cleanAttachmentspaperLCA.length > 0) {
                  dispatch(
                    addDocumentStart({
                      coll: "Document",
                      refColl: "LCA",
                      refId: parentId,
                      refField: "attachments.paper",
                      payload: {
                        addedBy: loginUserUiid,
                        attachments: [
                          {
                            parent: { employee: employeeProfileUiid },
                            addedBy: loginUserUiid,
                            docType: "online Paper",
                            ref: {
                              id: parentId,
                              entity: "LCA",
                              path: `attachments.paper`,
                            },
                            file: cleanAttachmentspaperLCA.map((obj) => ({
                              name: "online Paper",
                              comments: "online Paper",
                              keys: fileData
                                .filter(
                                  (file) =>
                                    file?.fileRefId === obj.id && file.key,
                                )
                                .map((file) => file.key),
                            })),
                          },
                        ],
                      },
                    }),
                  );
                  await delay(300);
                }

                setActiveTab((prev) => prev + 1);
              },
            }),
          );
        };

        // MAIN ENTRY
        if (hasAnyDocs) {
          // perform upload first
          dispatch(
            uploadStart({
              uploadType: "multiple",
              field: "doc",
              uiid: employeeProfileUiid,
              entity: "lcas",
              category: "lca",
              coll: "LCA",
              doc: combineAllFiles,
              onSuccess: async (fileData) => {
                await handleAddImmigration(fileData);
              },
            }),
          );
        } else {
          // skip upload entirely
          handleAddImmigration([]);
        }
      } else {
        console.log("form errors is the :", errors);
        showToast("Please fill in all the required fields before saving", "error");
      }
    } catch (e) {
      console.error("Error in handleSave for lcaINformation add and save", e);
    } finally {
    }
  };

  const getCurrentPlace = () => {
    const placeKey = `place${activeTabInner}`;
    return formData.employmentPlace[placeKey] || {};
  };

  const getCurrentPlaceErrors = () => {
    return errors?.employmentPlace?.[`place${activeTabInner}`] || {};
  };

  const getCurrentAd = () => {
    const adKey = `ad${activeAdTab}`;
    return formData.advertisements[adKey] || {};
  };

  const getCurrentAdErrors = () => {
    return errors?.advertisements?.[`ad${activeAdTab}`] || {};
  };
  useEffect(() => {
    const lcaInfo = currentImmgration?.lcaInfo;
    if (!lcaInfo) return;
    // Simple flat fields
    // Simple flat fields update
    const updatedFormData = {
      // ...formData,
      lcaNumber: lcaInfo.number ?? "",
      lcaStatus: lcaInfo.status ?? "",
      jobTitle: lcaInfo.jobTitle ?? "",
      employmentStartDate: lcaInfo.startDate ?? "",
      employmentEndDate: lcaInfo.endDate ?? "",
      certificationDate: lcaInfo.certifyDate ?? "",
      positionsRequested: lcaInfo.positionReq ?? "",
      socCode: lcaInfo.soc?.code ?? "",
      socOccupationTitle: lcaInfo.soc?.title ?? "",
      includePoNumber: lcaInfo.includePONum === true ? "exempt" : "nonexempt",
    };
    // Salary Info - Ensure fields are handled correctly
    const salaryInfo = lcaInfo.salaryInfo ?? {};
    updatedFormData.wageRateUSD = `${salaryInfo.wageRate ?? ""}`;
    updatedFormData.wageRatePer = salaryInfo.duration ?? "";
    updatedFormData.wageLevel = salaryInfo.level ?? "";
    updatedFormData.sourceFrom = salaryInfo.sourceYear?.from ?? "";
    updatedFormData.sourceTo = salaryInfo.sourceYear?.to ?? "";
    updatedFormData.wageRateFromUSD = salaryInfo.range?.from ?? "";
    updatedFormData.wageRateToUSD = salaryInfo.range?.to ?? "";
    // Handle placeOfEmployment - Update the employmentPlace field
    if (Array.isArray(lcaInfo.placeOfEmployment)) {
      const updatedEmploymentPlace = { ...formData.employmentPlace };
      lcaInfo.placeOfEmployment.forEach((data, index) => {
        const placeKey = `place${index + 1}`;
        console.log("data", data);
        updatedEmploymentPlace[placeKey] = {
          endClient: data?.endClient ?? "",
          addressLine1: data?.address?.addressLine1 ?? "",
          addressLine2: data?.address?.addressLine2 ?? "",
          country: data?.address?.country ?? "",
          state: data?.address?.state ?? "",
          city: data?.address?.city ?? "",
          zipCode: data?.address?.zipCode ?? "",
          county: data?.county ?? "",
          prevailingWageUSD: data?.prevailWage ?? "",
        };
      });
      updatedFormData.employmentPlace = updatedEmploymentPlace;
    }
    setFormData(updatedFormData);
  }, [currentImmgration]);
  useEffect(() => {
    const lcaInfo = editData;
    const lcaInfoData = currentImmgration?.lcaInfo;
    // 1. If lcaInfo is empty/null and not in edit mode, skip
    if (
      (!lcaInfo ||
        (typeof lcaInfo === "object" && Object.keys(lcaInfo).length === 0)) &&
      !isEditable
    ) {
      return;
    }
    // 2. If lcaInfoData exists and has data, skip or return ''
    if (currentImmgration && Object.keys(currentImmgration).length > 0) {
      return "";
    }

    // Simple flat fields
    // Simple flat fields update
    const updatedFormData = {
      ...formData,
      lcaNumber: lcaInfo.number ?? "",
      lcaStatus: lcaInfo.status ?? "",
      jobTitle: lcaInfo.jobTitle ?? "",
      employmentStartDate: lcaInfo.startDate ?? "",
      employmentEndDate: lcaInfo.endDate ?? "",
      certificationDate: lcaInfo.certifyDate ?? "",
      positionsRequested: lcaInfo.positionReq ?? "",
      socCode: lcaInfo.soc?.code != null ? `${lcaInfo.soc.code}` : "",
      socOccupationTitle: lcaInfo.soc?.title ?? "",
      includePoNumber: lcaInfo.includePONum === true ? "exempt" : "nonexempt",
    };
    // Salary Info - Ensure fields are handled correctly
    const salaryInfo = lcaInfo.salaryInfo ?? {};
    updatedFormData.wageRateUSD = `${salaryInfo.wageRate ?? ""}`;
    updatedFormData.wageRatePer = salaryInfo.duration ?? "";
    updatedFormData.wageLevel = salaryInfo.level ?? "";
    updatedFormData.sourceFrom = salaryInfo.sourceYear?.from ?? "";
    updatedFormData.sourceTo = salaryInfo.sourceYear?.to ?? "";
    updatedFormData.wageRateFromUSD =
      salaryInfo.range?.from != null ? `${salaryInfo.range.from}` : "";

    updatedFormData.wageRateToUSD =
      salaryInfo.range?.to != null ? `${salaryInfo.range.to}` : "";
    // Handle placeOfEmployment - Update the employmentPlace field
    if (Array.isArray(lcaInfo.placeOfEmployment)) {
      const updatedEmploymentPlace = { ...formData.employmentPlace };
      lcaInfo.placeOfEmployment.forEach((data, index) => {
        const placeKey = `place${index + 1}`;
        console.log("data", data);
        updatedEmploymentPlace[placeKey] = {
          endClient: data?.endClient ?? "",
          addressLine1: data?.address?.addressLine1 ?? "",
          addressLine2: data?.address?.addressLine2 ?? "",
          country: data?.address?.country ?? "",
          state: data?.address?.state ?? "",
          city: data?.address?.city ?? "",
          zipCode: data?.address?.zipCode ?? "",
          county: data?.county ?? "",
          prevailingWageUSD: data?.prevailWage ?? "",
        };
      });
      updatedFormData.employmentPlace = updatedEmploymentPlace;
    }
    setFormData(updatedFormData);
  }, [editData]);
  const combinePaperAttachments = !currentImmgration?.lcaInfo
    ? transformFiles(editData?.attachments?.paper || [])
    : [];

  const combineCertifiedAttachments = !currentImmgration?.lcaInfo
    ? transformFiles(editData?.attachments?.certified || [])
    : [];

  return (
    <>
      <div className="px-6 py-6 border-[1px] border-neutrals-50">
        <div>
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"PLACEMENT INFORMATION"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 max-w-7xl">
          <FormFieldSet
            type="text"
            title="LCA Number"
            placeholder="Enter LCA Number"
            value={formData.lcaNumber}
            onChange={(value) => handleChange("lcaNumber", value)}
            error={errors.lcaNumber}
          />
          <FormFieldSet
            type="select"
            title="LCA Status"
            placeholder="Select LCA Status"
            value={formData.lcaStatus}
            onChange={(value) => handleChange("lcaStatus", value)}
            error={errors.lcaStatus}
            options={LcaStatus}
          />
          <FormFieldSet
            type="jobTitle"
            title="Job Title"
            placeholder="Enter Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showSearch
            showButton
          />
          <FormFieldSet
            type="datepicker"
            title="Employment Start Date"
            placeholder="Select Employment Start Date"
            value={formData.employmentStartDate}
            onChange={(value) => handleChange("employmentStartDate", value)}
            error={errors.employmentStartDate}
            maxDate={formData?.employmentEndDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title="Employment End Date"
            placeholder="Select Employment End Date"
            value={formData.employmentEndDate}
            onChange={(value) => handleChange("employmentEndDate", value)}
            error={errors.employmentEndDate}
            minDate={formData?.employmentStartDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title="Certification Date"
            placeholder="Select Certification Date"
            value={formData.certificationDate}
            onChange={(value) => handleChange("certificationDate", value)}
            error={errors.certificationDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title="Positions Requested"
            placeholder="Enter "
            value={formData.positionsRequested}
            onChange={(value) => handleChange("positionsRequested", value)}
            error={errors.positionsRequested}
          />
          <FormFieldSet
            type="text"
            title="SOC (ONET/OES) Code"
            placeholder="Enter "
            value={formData.socCode}
            onChange={(value) => handleChange("socCode", value)}
            error={errors.socCode}
          />
          <FormFieldSet
            type="text"
            title="SOC (ONET/OES) Occupation Title"
            placeholder="Enter"
            value={formData.socOccupationTitle}
            onChange={(value) => handleChange("socOccupationTitle", value)}
            error={errors.socOccupationTitle}
          />
        </div>
        <div className="mt-6">
          <FormFieldSet
            type="radio"
            title={"Include PO Number"}
            options={[
              {
                label: "Nonexempt",
                value: "nonexempt",
              },
              { label: "Exempt", value: "exempt" },
            ]}
            value={formData.includePoNumber}
            onChange={(event) =>
              handleChange("includePoNumber", event.target.value)
            }
            error={errors.includePoNumber}
          />
        </div>
        <div className="mt-6">
          {formData?.visaClassification?.map((row, index) => (
            <div key={row.id} className="grid grid-cols-2 xl:grid-cols-3 gap-8 mb-4">
              <FormFieldSet
                type="select"
                title="Visa Classification"
                placeholder="Select Visa Classification"
                value={row.visaClasificationSelect}
                onChange={(value) =>
                  handleVisaChange(index, "visaClasificationSelect", value)
                }
                error={
                  errors?.visaClassification?.[index]?.visaClasificationSelect
                }
                options={visaClassificationOptions}
              />
              <div className="flex gap-2 items-start mt-8">
                <Button
                  type="icon"
                  size="xs"
                  icon="add"
                  color="black"
                  onClick={handleAddVisaRow}
                />
                <Button
                  type="icon"
                  size="xs"
                  icon="remove"
                  color="danger"
                  onClick={() => handleRemoveVisaRow(row.id)}
                  disabled={formData.visaClassification.length === 1}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENT"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 max-w-7xl">
          <FormFieldSet
            type="file"
            title="Paper LCA"
            placeholder="Choose File"
            value={formData.paperLCA}
            onChange={(value) => handleChange("paperLCA", value)}
            error={errors.paperLCA}
            multiple
          />
          <FormFieldSet
            type="file"
            title="Certified LCA"
            placeholder="Choose File"
            value={formData.certifiedLCA}
            onChange={(value) => handleChange("certifiedLCA", value)}
            error={errors.certifiedLCA}
            multiple
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 max-w-7xl">
          {editData && (
            <div
              className=" flex rounded-md items-center cursour-pointer"
              onClick={() => {
                setAttachmentModal(!attachmentModal);
                setAttachmentModalName("paper");
              }}
            >
              <Chip
                label={`Attachments Paper:-${combinePaperAttachments.length}`}
                icon={"docs"}
                iconPosition={"before"}
              />
            </div>
          )}
          {editData && (
            <div
              className=" flex rounded-md items-center cursour-pointer"
              onClick={() => {
                setAttachmentModal(!attachmentModal);
                setAttachmentModalName("certified");
              }}
            >
              <Chip
                label={`Attachments Certified:-${combineCertifiedAttachments.length}`}
                icon={"docs"}
                iconPosition={"before"}
              />
            </div>
          )}
        </div>
        <div className="mt-6">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"SALARY INFORMATION"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 max-w-7xl">
          <FormFieldSet
            type="text"
            title="Prevailing Wage Rate (USD)."
            placeholder="Enter "
            value={formData.wageRateUSD}
            onChange={(value) => handleChange("wageRateUSD", value)}
            error={errors.wageRateUSD}
          />
          <FormFieldSet
            type="text"
            title="Wage Rate From (USD)"
            placeholder="Enter"
            value={formData.wageRateFromUSD}
            onChange={(value) => handleChange("wageRateFromUSD", value)}
            error={errors.wageRateFromUSD}
          />
          <FormFieldSet
            type="text"
            title="Wage Rate To (USD)"
            placeholder="Enter"
            value={formData.wageRateToUSD}
            onChange={(value) => handleChange("wageRateToUSD", value)}
            error={errors.wageRateToUSD}
          />
          <FormFieldSet
            type="select"
            title="Wage Rate Per"
            placeholder="Enter"
            value={formData.wageRatePer}
            onChange={(value) => handleChange("wageRatePer", value)}
            error={errors.wageRatePer}
            options={[
              { label: "hour", value: 1 },
              { label: "week", value: 2 },
              { label: "bi-week", value: 3 },
              { label: "month", value: 4 },
              { label: "year", value: 5 },
            ]}
          />
          <FormFieldSet
            type="checkbox"
            title="Wage Level"
            options={[
              {
                label: "I",
                value: "1",
              },
              {
                label: "II",
                value: "2",
              },
              {
                label: "III",
                value: "3",
              },
              {
                label: "IV",
                value: "4",
              },
              {
                label: "V",
                value: "5",
              },
            ]}
            values={formData.wageLevel || []}
            onChange={(value) => handleChange("wageLevel", value)}
            error={errors.wageLevel}
          />
          {/* <FormFieldSet
          type="text"
          title="Source Year"
          placeholder="Enter"
          value={formData.sourceYear}
          onChange={(value) => handleChange("sourceYear", value)}
          error={errors.sourceYear}
        /> */}
          <FormFieldSet
            type="datepicker"
            title="Source From"
            placeholder="Enter"
            value={formData.sourceFrom}
            onChange={(value) => handleChange("sourceFrom", value)}
            error={errors.sourceFrom}
            maxDate={formData?.sourceTo}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title="Source To"
            placeholder="Enter"
            value={formData.sourceTo}
            onChange={(value) => handleChange("sourceTo", value)}
            error={errors.sourceTo}
            minDate={formData?.sourceFrom}
            showDropdown={false}
          />
        </div>
        <div className="mt-6">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"PLACE OF EMPLOYMENT"} tag="p" />
              </div>
            }
          />
          <Divider />
          <div className="tabs mt-3">
            <div className="flex gap-2 flex-wrap">
              {[1, 2, 3, 4].map((tabIndex) => (
                <Button
                  key={tabIndex}
                  title={`Place of employment ${tabIndex}`}
                  variant={activeTabInner === tabIndex ? "text" : "text"}
                  onClick={() => setActiveTabInner(tabIndex)}
                  color={activeTabInner === tabIndex ? "primary " : "black"}
                  className={
                    activeTabInner === tabIndex
                      ? " border-b-2 border-primary text-primary rounded-none"
                      : " border-b-2 border-white text-black rounded-none"
                  }
                />
              ))}
            </div>
            <Divider />
            <div className="flex gap-3">
              <div className="mt-2 grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1">
                {activeTabInner === 1 && (
                  <FormFieldSet
                    type="text"
                    title="End Client"
                    placeholder="Enter"
                    value={getCurrentPlace().endClient || ""}
                    onChange={(value) =>
                      handleEmploymentPlaceChange("endClient", value)
                    }
                    error={getCurrentPlaceErrors().endClient}
                  />
                )}
                <FormFieldSet
                  type="text"
                  title="Address Line 1"
                  placeholder="Enter"
                  value={getCurrentPlace().addressLine1 || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("addressLine1", value)
                  }
                  error={getCurrentPlaceErrors().addressLine1}
                />
                <FormFieldSet
                  type="text"
                  title="Address Line 2"
                  placeholder="Enter"
                  value={getCurrentPlace().addressLine2 || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("addressLine2", value)
                  }
                  error={getCurrentPlaceErrors().addressLine2}
                />

                <FormFieldSet
                  type="countriesUsAndCanada"
                  title="Country"
                  placeholder="Select Country"
                  value={getCurrentPlace().country || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("country", value)
                  }
                  error={getCurrentPlaceErrors().country}
                  options={countryListOptions}
                />
                {/* <FormFieldSet
                type="select"
                title="State"
                placeholder="Select State"
                value={getCurrentPlace().state || ""}
                onChange={(value) =>
                  handleEmploymentPlaceChange("state", value)
                }
                error={getCurrentPlaceErrors().state}
                options={cityStateListOptions}
              />
               <FormFieldSet
                type="text"
                title="City"
                placeholder="Enter"
                value={getCurrentPlace().city || ""}
                onChange={(value) => handleEmploymentPlaceChange("city", value)}
                error={getCurrentPlaceErrors().city}
              /> */}
                <FormFieldSet
                  type="states"
                  title="State"
                  placeholder="Select State"
                  value={getCurrentPlace().state || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("state", value)
                  }
                  error={getCurrentPlaceErrors().state}
                  options={cityStateListOptions}
                  disabled={!getCurrentPlace().country}
                  parentValue={{
                    country:
                      getCurrentPlace().country?.value ??
                      getCurrentPlace().country,
                  }}
                  showSearch
                />
                <FormFieldSet
                  type="cities"
                  title="City"
                  placeholder="Select City"
                  value={getCurrentPlace().city || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("city", value)
                  }
                  error={getCurrentPlaceErrors().city}
                  disabled={!getCurrentPlace().state}
                  parentValue={{
                    country:
                      getCurrentPlace().country?.value ??
                      getCurrentPlace().country,
                    state:
                      getCurrentPlace().state?.value ?? getCurrentPlace().state,
                  }}
                  showSearch
                />
                <FormFieldSet
                  type="text"
                  title="County"
                  placeholder="Select County"
                  value={getCurrentPlace().county || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("county", value)
                  }
                  error={getCurrentPlaceErrors().county}
                />
                <FormFieldSet
                  type="text"
                  title="Zip Code"
                  placeholder="Enter"
                  value={getCurrentPlace().zipCode || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("zipCode", value)
                  }
                  error={getCurrentPlaceErrors().zipCode}
                />
                <FormFieldSet
                  type="text"
                  title="Prevailing Wage (USD)"
                  placeholder="Enter"
                  value={getCurrentPlace().prevailingWageUSD || ""}
                  onChange={(value) =>
                    handleEmploymentPlaceChange("prevailingWageUSD", value)
                  }
                  error={getCurrentPlaceErrors().prevailingWageUSD}
                />
              </div>
              <div className="flex-end mt-5">
                {activeTabInner !== 1 && (
                  <Button
                    type="icon"
                    variant="text"
                    icon="delete"
                    onClick={() => openResetModal(activeTabInner)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"ADVERTISEMENTS"} tag="p" />
            </div>
          }
        />
        <Divider />
        <div className="tabs mt-3">
          <div className="flex gap-2">
            {[1, 2, 3, 4].map((tabIndex) => (
              <Button
                key={tabIndex}
                title={`Advertisement ${tabIndex}`}
                variant={activeAdTab === tabIndex ? "text" : "text"}
                onClick={() => setActiveAdTab(tabIndex)}
                color={activeAdTab === tabIndex ? "primary " : "black"}
                className={
                  activeAdTab === tabIndex
                    ? " border-b-2 border-primary text-primary rounded-none"
                    : " border-b-2 border-white text-black rounded-none"
                }
              />
            ))}
          </div>
          <Divider />
          <div className="mt-2 grid grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1">
            <FormFieldSet
              type="text"
              title="Advertisement Type"
              placeholder="Enter"
              value={getCurrentAd().advertisementType || ""}
              onChange={(value) =>
                handleAdvertisementChange("advertisementType", value)
              }
              error={getCurrentAdErrors().advertisementType}
            />
            <FormFieldSet
              type="select"
              title="Posted At"
              placeholder="Select"
              value={getCurrentAd().postedAt || ""}
              onChange={(value) => handleAdvertisementChange("postedAt", value)}
              error={getCurrentAdErrors().postedAt}
              options={LcaAdsPostAt}
            />
            <FormFieldSet
              key={`ad-datepicker-${activeAdTab}-displayedFrom`}
              type="datepicker"
              title="Displayed From"
              placeholder="Select Date"
              value={getCurrentAd().displayedFrom || ""}
              onChange={(value) =>
                handleAdvertisementChange("displayedFrom", value)
              }
              error={getCurrentAdErrors().displayedFrom}
            />
            <FormFieldSet
              key={`ad-datepicker-${activeAdTab}-displayedUntil`}
              type="datepicker"
              title="Displayed Until"
              placeholder="Select Date"
              value={getCurrentAd().displayedUntil || ""}
              onChange={(value) =>
                handleAdvertisementChange("displayedUntil", value)
              }
              error={getCurrentAdErrors().displayedUntil}
            />
            <FormFieldSet
              key={`ad-datepicker-${activeAdTab}-attachment`}
              type="file"
              title="Attachment"
              placeholder="Choose File"
              value={getCurrentAd().attachment || []}
              onChange={(value) =>
                handleAdvertisementChange("attachment", value)
              }
              error={getCurrentAdErrors().attachment}
              multiple
            />
            <FormFieldSet
              type="checkbox"
              title=""
              options={[
                {
                  label: "Display on Dashboard",
                  value: "1",
                },
              ]}
              values={getCurrentAd().displayOnDashboard || ""}
              onChange={(value) =>
                handleAdvertisementChange("displayOnDashboard", value)
              }
              multiple
              error={getCurrentAdErrors().displayOnDashboard}
            />
          </div>
        </div>
      </div> */}

        {/* <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"LCA DOCUMENTS"} tag="p" />
            </div>
          }
        />
        <Divider />
        <div className="grid grid-cols-3 gap-x-6 gap-y-8 mt-4 max-w-7xl">
          <FormFieldSet
            type="select"
            title="Document Type"
            placeholder="Select Document Type"
            value={formData.documentType}
            onChange={(value) => handleChange("documentType", value)}
            error={errors.documentType}
          />
        </div>
      </div> */}

        {/* <div className="max-w-7xl mt-6">{renderAttachments(AttachmentField)}</div> */}
        <div className="flex gap-3 justify-end my-6">
          <Button title="Cancel" variant="outlined" />
          <Button title="Save" onClick={() => handleSave()} />
        </div>
        <ResetModal
          isOpen={showResetModal}
          onClose={() => closeResetModal()}
          onConfirm={() => handleResetEmploymentPlace()}
          title="Clear LCA Place Of Employment"
        />
        <Modal
          isOpen={attachmentModal}
          onClose={() => {
            setAttachmentModal(false);
            setAttachmentModalName("");
          }}
          // title="Attachment View"
          // width="max-w-5xl"
          width="max-w-2xl"
          title={"Document Details"}
        >
          {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
          <DocumentsList
            data={
              attchmentModalName === "paper"
                ? combinePaperAttachments
                : attchmentModalName === "certified"
                  ? combineCertifiedAttachments
                  : []
            }
          />
          {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
          {/* </div> */}
        </Modal>
      </div>
    </>
  );
};

export default LCAInformation;
